<template>
  <div>
    <v-menu
      v-model="menu"
      :disabled="disabled"
      :close-on-content-click="false"
      :nudge-top="-4"
      offset-y>
      <template #activator="{ on, attrs }">
        <v-tooltip
          :disabled="disabled"
          :value="Boolean(tooltipSelectedItems)"
          max-width="300"
          bottom>
          <template #activator="tooltip">
            <div
              v-bind="tooltip.attrs"
              v-on="tooltip.on">
              <v-text-field
                class="ad-event-page-select__text-field"
                :class="{
                  'ad-event-page-select__text-field--disabled': disabled,
                }"
                :disabled="disabled"
                :loading="loading"
                :value="label"
                :placeholder="
                  loading || $apollo.loading
                    ? 'กำลังดึงข้อมูล...'
                    : disabled
                      ? 'เปิดใช้งานปุ่มสถานะเพื่อเลือกจัดการเพจ'
                      : 'คลิกเพื่อจัดการเพจ'
                "
                append-icon="mdi-menu-down"
                dense
                outlined
                hide-details
                readonly
                v-bind="attrs"
                v-on="on" />
            </div>
          </template>
          {{ tooltipSelectedItems }}
        </v-tooltip>
      </template>
      <v-card class="px-3">
        <v-text-field
          :value="searchText"
          :placeholder="$t('app.form.search.placeholder')"
          class="pa-4 pb-1"
          prepend-inner-icon="mdi-magnify"
          autofocus
          hide-details
          dense
          outlined
          @input="$emit('update:search-text', $event)" />
        <v-radio-group
          :value="selectedAllPages"
          class="mx-4"
          hide-details
          @change="$emit('change:update-selected-all-pages', $event)">
          <v-radio
            :label="`ทุกเพจ`"
            :value="true" />
          <v-radio
            :label="`เลือกเพจ`"
            :value="false" />
        </v-radio-group>
        <v-list-item class="px-7">
          <v-list-item-content class="pa-0 mb-3">
            <div class="mt-2">
              <div
                v-for="item in pages"
                :key="`checkbox-item-${item.value}`"
                style=""
                class="ad-event-page-select__checkbox d-flex align-center pl-4">
                <v-checkbox
                  v-if="filteredItem(item)"
                  v-model="item.selected"
                  :label="item.text"
                  :disabled="item.disabled"
                  @change="
                    $emit('change:update-selected-items', {
                      item,
                      checked: $event,
                    })
                  " />
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: {
    searchText: {
      type: String,
      default: ''
    },
    pages: {
      type: Array,
      default: () => []
    },
    initSelectedAllPages: {
      type: Boolean
    },
    selectedAllPages: {
      type: Boolean
    },
    initSelectedItems: {
      type: Array,
      default: () => []
    },
    selectedItems: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  data () {
    return {
      menu: false
    }
  },
  computed: {
    label () {
      if (this.selectedAllPages) {
        return 'ทุกเพจ'
      }
      let label = ''
      if (this.selectedItems[0]) {
        label += this.selectedItems[0].text
      }
      if (this.selectedItems[1]) {
        label += ` (+${this.selectedItems.length - 1} others)`
      }
      return label
    },
    tooltipSelectedItems () {
      return this.selectedItems.map((item) => item.text).join(', ')
    }
  },
  methods: {
    comparator (item, value) {
      return item.value === value.value
    },
    filteredItem (item) {
      return item.text.includes(this.searchText)
    }
  }
}
</script>

<style scoped lang="scss">
.v-list-item.h-38 {
  min-height: 38px;
}

.ad-event-page-select {
  &__text-field {
    &--disabled {
      ::v-deep {
        .v-text-field__slot {
          input {
            cursor: default;
          }
        }
      }
    }
  }
  &__checkbox {
    max-height: 40px;
  }
}
</style>
